// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"823":"3df11d81","909":"8ca4f8cf","939":"8ca4f8cf"}[chunkId] + ".chunk.css";
};